import React, { Component } from "react";
import { connect } from "react-redux";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

import SideBarNew from "../../SideBarNew";
import TopBarNew from "../../TopBarNew";
import * as API from "../../api";
import MenuIcon from "../../icons/MenuIcon.svg";
import TowerIcon2 from "../../icons/TowerIcon2.svg";
import { activesubscription } from "../../redux";
import LoaderComponent from "../../ReusableComponents/LoaderComponent";

ChartJS.register(ArcElement, Tooltip, Legend);

class AllDefects extends Component {
  state = {
    user: {},
    sidebarMode: "shrunk",
    showBackIcon: true,
    defects: null,
    loading: true,
  };

  componentWillMount() {
    if (this.props.location.state) {
      const { user, sidebarMode,severity,sevarityFormatted } = this.props.location.state;
      this.setState({ user, sidebarMode });

      const COLORS = [
        "#3366CC","#DC3912","#FF9900","#109618","#990099",
        "#0099C6","#DD4477","#66AA00","#B82E2E","#316395",
        "#994499","#22AA99","#AAAA11","#6633CC","#E67300",
        "#8B0707","#329262","#5574A6","#3B3EAC","#FF6600",
        "#0099C6","#DD4477","#66AA00","#B82E2E","#316395",
        "#994499","#22AA99","#AAAA11","#6633CC","#E67300",
    ];
      console.log(user,'user')
      API.getTransmissonDashboardStats(user.userid)
        .then((res) => {
          const defectsData = {
            labels: res.data.objectCounts.map(
              (obj) =>
                obj.objectType.charAt(0).toUpperCase() + obj.objectType.slice(1)
            ),
            datasets: [
              {
                data: res.data.objectCounts.map((obj) => obj.count),
                backgroundColor: res.data.objectCounts.map(
                  (_, i) => COLORS[i % COLORS.length]
                ),
                borderWidth: 0,
              },
            ],
          };
          this.setState({ defects: defectsData, loading: false });
        })
        .catch((err) => {
          console.error("Error fetching defects:", err);
          this.setState({ loading: false });
        });
    }
  }

  render() {
    const { user, sidebarMode, showBackIcon, defects, loading } = this.state;

    let sidebarConfigurations = {
      options:
        showBackIcon === true
          ? [
              { icon: MenuIcon, text: "Home", path: "/picstork/dashboard" },
              { icon: TowerIcon2, text: "Projects", path: "/picstork/towers" },
            ]
          : null,
      user,
      type: user.type,
      mode: sidebarMode,
      picStorkHelp: true,
    };

    let topbarConfigurations = {
      options:
        showBackIcon === true
          ? [{ icon: MenuIcon, text: "Dashboard", path: "/picstork/dashboard" },
            { icon: MenuIcon, text: "Total Defects", path: "/picstork/alldefects" }
          ]
          : null,
      user,
      type: user.type,
      mode: sidebarMode,
      picStorkHelp: true,
    };
    const totalDefects = defects
    ? defects.datasets[0].data.reduce((a, b) => a + b, 0)
    : 0;


    return user.username ? (
      <div className="wrapper" style={{ backgroundColor:"#FFFFFF" }}>
        <SideBarNew
          config={sidebarConfigurations}
          showMainDashboardIcons={showBackIcon}
        />
        <div className="right-content">
          <TopBarNew config={topbarConfigurations} />

          <div
            className="main-content"
            style={{
              background: "none",
              display: "flex",
              flexDirection: "column",
              marginTop: "20px",
            }}
          >
            <div style={{marginBottom:"10px", fontSize:"1.1rem"}}>Total Defects {defects ? `(${totalDefects})` : ""}</div>
            <div
              style={{
                display: "flex",
                gap: "20px",
                padding: "20px",
                background: "#fff",
                borderRadius: "10px",
                boxShadow: "0px 5px 10px rgba(0,0,0,0.18)",
                height: "80vh",
              }}
            >
              <div
                style={{
                  flex: "0 0 25%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                {loading ? (
                  <div><LoaderComponent /></div>
                ) : defects ? (
                  <>
                    <Doughnut
                      data={defects}
                      options={{
                        cutout: "70%",
                        plugins: { legend: { display: false } },
                        maintainAspectRatio: false,
                        spacing: 2,
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: "22px",
                        fontWeight: "bold",
                      }}
                    >
                      {defects.datasets[0].data.reduce((a, b) => a + b, 0)}
                    </div>
                  </>
                ) : (
                  <div>No data</div>
                )}
              </div>

              <div
                style={{
                  flex: "1",
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                  gap: "15px 30px",
                  paddingLeft: "20px",
                   overflowY: "auto",
                }}
              >
                {defects &&
                (() => {
                  const total = defects.datasets[0].data.reduce((a, b) => a + b, 0);
                  return defects.labels.map((label, index) => {
                    const count = defects.datasets[0].data[index];
                    const percent = ((count / total) * 100).toFixed(1);
                    return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        fontSize: "0.95rem",
                      }}
                    >
                      <span
                        style={{
                          width: "14px",
                          height: "14px",
                          borderRadius: "50%",
                          background: defects.datasets[0].backgroundColor[index],
                          display: "inline-block",
                        }}
                      />
                      <span>
                        {label} - {defects.datasets[0].data[index]} ({percent}%)
                      </span>
                    </div>
                  );
                  });
                })()}
              </div>

            </div>
          </div>
        </div>
      </div>
    ) : (
      <div />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  activesubscription: (payload) => dispatch(activesubscription(payload)),
});

export default connect(null, mapDispatchToProps)(AllDefects);
